import "./App.css";
import CollageGrid from "./components/CollageGrid";
import filetmijohn from "./assets/filetmijohn.png";

// import CircleType from "circletype";
// import SongComponent from "./components/SongComponent";

function App() {
  // const circleInstance = useRef();

  // const circleStyle =  {
  //     width: "20rem"    
  //   }

  // useEffect(() => {
  //   new CircleType(circleInstance.current);
  // }, []);

  return (
    <div
      style={{ backgroundColor: "#ff00f0" }}
      className="relative overflow-hidden w-screen h-screen"
    >
      <CollageGrid />
      {/* <SongComponent /> */}
    
      {/* <div ref={circleInstance} className="absolute text-white text-5xl left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <span className=" tracking-widest">Clandestino Festival 20th anniversary 2022.</span>
            </div> */}
            <div className="absolute bg-clan-pink top-0 w-screen h-6">
      <div className="absolute top-0 text-white w-96 animate-scrollingText">
        <span className="relative whitespace-nowrap">Clandestino Festival 20th anniversary 9-12 june 2022. Clandestino Festival 20th anniversary 9-12 june 2022. Clandestino Festival 20th anniversary 9-12 june 2022. Clandestino Festival 20th anniversary 9-12 june 2022. Clandestino Festival 20th anniversary 9-12 june 2022. Clandestino Festival 20th anniversary 9-12 june 2022. Clandestino Festival 20th anniversary 9-12 june 2022. Clandestino Festival 20th anniversary 9-12 june 2022. Clandestino Festival 20th anniversary 9-12 june 2022.</span>
      </div></div>
      <div className="absolute text-white flex items-center w-screen bottom-40 md:bottom-10 text-2xl md:text-3xl lg:text-4xl flex-col">
        <a
          href="https://clandestinofestival.org/2022/biljetter/"
          target="_top"
          className="text-lg text-white md:text-lg lg:text-xl mt-8"
        >
          Early Bird out now!
        </a>
        <a
          // href="https://clandestinofestival.org/2022"
          href="https://clandestinofestival.org/2022/#close-start"
          target="_top"
          className="text-lg text-white md:text-lg lg:text-xl"
        >
          Continue to Clandestino Festival
        </a>
      </div>
      {/* <a
        href="https://filetmijohn.com"
        target="_top"
        className="absolute text-white opacity-50 bottom-32 md:bottom-4 right-4 text-xs"
      >
        Filet Mijohn
      </a> */}
      <img
        src={filetmijohn}
        alt="Filet Mijohn"
        width="30px"
        height="auto"
        className="absolute opacity-75 bottom-32 md:bottom-4 right-4"
        onClick={()=> window.open("https://www.filetmijohn.com", "_top")} 
      ></img>
    </div>
  );
}

export default App;
